module.exports = __webpack_public_path__ + "1.4.15-unryo/img/online-database-5.c307a17b.svg";